import { useState } from "react";
import environment from "environment";
import { BaseService } from "@services/BaseService";
import type { Destination } from "@components/destinations/Destinations.types";
import { t } from "i18next";

const useDestinations = () => {
  const [destinations, setDestinations] = useState<Destination[]>();
  const [error, setError] = useState<string>();
  const [isLoading, setIsLoading] = useState(false);

  const fetDestinations = (orgId: string) => {
    setIsLoading(true);
    setError("");

    const apiUrl = environment.api.organisationInfo + `/${orgId}/destinations`;

    BaseService.get<Destination[]>(apiUrl)
      .then(({ data }) => {
        setDestinations(data);
      })
      .catch(() => {
        setError(t("core:accountConfig:fetch_failure") || undefined);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return {
    fetDestinations,
    destinations,
    error,
    isLoading,
  };
};

export default useDestinations;
